import React from 'react'
import { NonIdealState } from '@blueprintjs/core'

export default () => <NonIdealState icon='error' title='PAGE NOT FOUND' description='Invalid URL' />
